import { Dismiss } from '@doist/icons/product-ui';
import { Divider, Image, Text } from '@doist/marketist';
import cn from 'clsx';
import { ProductUIBoxShadow } from 'components/product-ui/product-ui-box-shadow/product-ui-box-shadow';
import css from './product-ui-template-gallery.module.css';
export type ProductUITemplateGalleryProps = {
  title: string;
  sections: React.ReactNode[];
};
export function ProductUITemplateGallery({
  title,
  sections
}: ProductUITemplateGalleryProps) {
  return <div className={css.templateGallery} data-sentry-component="ProductUITemplateGallery" data-sentry-source-file="product-ui-template-gallery.tsx">
            <div className={cn(css.header, 'pb-12 pi-24')}>
                <Text size="minor-lg" weight="semibold" data-sentry-element="Text" data-sentry-source-file="product-ui-template-gallery.tsx">
                    {title}
                </Text>
                <Dismiss width={20} height={20} color="var(--display-onlight-secondary)" data-sentry-element="Dismiss" data-sentry-source-file="product-ui-template-gallery.tsx" />
            </div>
            <Divider data-sentry-element="Divider" data-sentry-source-file="product-ui-template-gallery.tsx" />
            <div className={cn(css.sections, 'pb-24 pi-24')}>{sections}</div>
        </div>;
}
export type ProductUITemplateGallerySectionProps = {
  title: string;
  items: React.ReactNode[];
};
export function ProductUITemplateGallerySection({
  title,
  items
}: ProductUITemplateGallerySectionProps) {
  return <div className={css.section} data-sentry-component="ProductUITemplateGallerySection" data-sentry-source-file="product-ui-template-gallery.tsx">
            <Text size="minor-base" weight="semibold" className="mbe-8" data-sentry-element="Text" data-sentry-source-file="product-ui-template-gallery.tsx">
                {title}
            </Text>
            <div className={css.items}>{items}</div>
        </div>;
}
export type ProductUITemplateGalleryItemProps = {
  title: string;
  description: string;
  image: string;
  backgroundColor?: string;
  dashed?: boolean;
  hover?: boolean;
};
export function ProductUITemplateGalleryItem({
  title,
  description,
  image,
  backgroundColor,
  dashed,
  hover
}: ProductUITemplateGalleryItemProps) {
  return <div className={cn(css.item, {
    [css.dashed]: dashed,
    [css.hover]: hover
  })} data-sentry-component="ProductUITemplateGalleryItem" data-sentry-source-file="product-ui-template-gallery.tsx">
            <ProductUIBoxShadow data-sentry-element="ProductUIBoxShadow" data-sentry-source-file="product-ui-template-gallery.tsx" />
            <div className={css.itemImage} style={{
      backgroundColor
    }}>
                <Image src={image} width={84} height={84} alt="" data-sentry-element="Image" data-sentry-source-file="product-ui-template-gallery.tsx" />
            </div>
            <div className="pb-12 pi-12">
                <Text className={css.itemTitle} size="minor-sm" weight="semibold" data-sentry-element="Text" data-sentry-source-file="product-ui-template-gallery.tsx">
                    {title}
                </Text>
                <Text className={css.itemDescription} size="body-2xs" color="var(--display-onlight-secondary)" data-sentry-element="Text" data-sentry-source-file="product-ui-template-gallery.tsx">
                    {description}
                </Text>
            </div>
        </div>;
}